<template>
  <div class="rs-listing__filters">
    <div class="rs-listing__filters__top">
      <div class="rs-listing__filters__top__filter">
        <button v-on:click="toggleExpansion">
          <svg
            v-bind:class="isExpanded && 'rs-listing__rotate180'"
            xmlns="http://www.w3.org/2000/svg"
            width="11.064"
            height="8.424"
            viewBox="0 0 11.064 8.424"
          >
            <path
              id="Path_44"
              data-name="Path 44"
              d="M7.584-3.288,1.728-8.808l5.856-5.544h2.568L4.272-8.808l5.88,5.52Z"
              transform="translate(14.352 10.152) rotate(-90)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Filter']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__category">
        <button v-on:click="toggleExpansion">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="20"
            viewBox="0 0 25 20"
          >
            <path
              id="Path_139"
              data-name="Path 139"
              d="M23.75-17.5H6.25A1.2,1.2,0,0,0,5-16.354v3.229H6.875v-2.5H8.75v2.5h1.875v-2.5h8.75V-3.75H23.75A1.2,1.2,0,0,0,25-4.9V-16.354A1.2,1.2,0,0,0,23.75-17.5ZM23.125-5.625H21.25V-7.812h1.875Zm0-4.062H21.25v-1.875h1.875Zm0-3.75H21.25v-2.187h1.875ZM5-5A1.251,1.251,0,0,0,6.25-6.25,1.251,1.251,0,0,0,5-7.5,1.251,1.251,0,0,0,3.75-6.25,1.251,1.251,0,0,0,5-5Zm11.25-6.25h-15A1.251,1.251,0,0,0,0-10V1.25A1.251,1.251,0,0,0,1.25,2.5h15A1.251,1.251,0,0,0,17.5,1.25V-10A1.251,1.251,0,0,0,16.25-11.25Zm-.625,9.375L11.692-5.808a.623.623,0,0,0-.442-.183.623.623,0,0,0-.442.183L6.875-1.875,5.442-3.308A.623.623,0,0,0,5-3.491a.623.623,0,0,0-.442.183L1.875-.625v-8.75h13.75Z"
              transform="translate(0 17.5)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Format']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__category">
        <button v-on:click="toggleExpansion">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.375"
            height="19.375"
            viewBox="0 0 19.375 19.375"
          >
            <path
              id="Path_141"
              data-name="Path 141"
              d="M9.687-17.187A9.686,9.686,0,0,0,0-7.5,9.686,9.686,0,0,0,9.687,2.187,9.686,9.686,0,0,0,19.375-7.5,9.686,9.686,0,0,0,9.687-17.187ZM8.437-15.2v.441a.626.626,0,0,1-.906.559l-.937-.469A7.886,7.886,0,0,1,8.437-15.2ZM9.687-.758V.312A7.82,7.82,0,0,1,1.875-7.5a7.785,7.785,0,0,1,.687-3.191c.387.574.984,1.461,1.352,2a4.36,4.36,0,0,0,.707.809l.031.027a5.7,5.7,0,0,0,1.234.852c.547.273,1.344.711,1.906,1.02a1.244,1.244,0,0,1,.645,1.094v1.25a1.248,1.248,0,0,0,.367.883A2.932,2.932,0,0,1,9.687-.758Zm1.668.887.68-1.832c.078-.215.129-.438.188-.66a.944.944,0,0,1,.242-.418l.441-.441a1.811,1.811,0,0,0,.535-1.289,1.194,1.194,0,0,0-.348-.844l-.535-.535a1.248,1.248,0,0,0-.883-.367H9.062c-.367-.184-.84-1.25-1.25-1.25a2.652,2.652,0,0,1-1.184-.281L6.2-8a.471.471,0,0,1-.258-.418.466.466,0,0,1,.32-.441L7.477-9.27a.619.619,0,0,1,.605.121l.363.316a.308.308,0,0,0,.2.078h.219a.314.314,0,0,0,.281-.453l-.609-1.219a.309.309,0,0,1,.063-.363l.387-.375a.307.307,0,0,1,.219-.09h.352a.316.316,0,0,0,.223-.09l.312-.312a.314.314,0,0,0,0-.441l-.184-.184a.314.314,0,0,1,0-.441l.4-.4.184-.184a.627.627,0,0,0,0-.883L9.391-15.3c.1,0,.2-.016.3-.016a7.815,7.815,0,0,1,6.98,4.324l-.508.254a.969.969,0,0,0-.359.316L15.035-9.27a.932.932,0,0,0,0,1.039l.7,1.055a.948.948,0,0,0,.551.391L17.43-6.5A7.827,7.827,0,0,1,11.355.129Z"
              transform="translate(0 17.188)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Language']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__category">
        <button v-on:click="toggleExpansion">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="16.25"
            viewBox="0 0 20 16.25"
          >
            <path
              id="Path_140"
              data-name="Path 140"
              d="M3.125-15.625H.625A.625.625,0,0,0,0-15v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-12.5V-15A.625.625,0,0,0,3.125-15.625Zm0,6.25H.625A.625.625,0,0,0,0-8.75v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-6.25v-2.5A.625.625,0,0,0,3.125-9.375Zm0,6.25H.625A.625.625,0,0,0,0-2.5V0A.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75,0V-2.5A.625.625,0,0,0,3.125-3.125Zm16.25-5.312H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-7.187v-.625A.625.625,0,0,0,19.375-8.437Zm0,6.25H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-.937v-.625A.625.625,0,0,0,19.375-2.187Zm0-12.5H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-13.437v-.625A.625.625,0,0,0,19.375-14.687Z"
              transform="translate(0 15.625)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Category']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__search">
        <button v-on:click="toggleExpansion">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20.001"
            height="20.001"
            viewBox="0 0 20.001 20.001"
          >
            <path
              id="Path_133"
              data-name="Path 133"
              d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
              transform="translate(0 17.5)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Search']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__reset">
        <transition name="rs-listing-reset">
          <button v-if="isFiltering" v-on:click="onResetButtonClick">
            <span v-html="fetchedStrings['Reset']" />
          </button>
        </transition>
      </div>
    </div>
    <div class="rs-listing__filters__divide">
      <hr />
    </div>
    <transition name="rs-listing__filters__expandable__transition">
      <div class="rs-listing__filters__expandable" v-if="isExpanded">
        <div class="rs-listing__filters__expandable__void"></div>
        <div class="rs-listing__filters__expandable__list">
          <label v-for="category in fetchedFormats" :key="category.slug">
            <input
              type="checkbox"
              v-model="localSelectedFormats"
              :value="category.slug"
              @change="onSelectedFiltersChange"
            />
            <span v-html="category.name" />
            <span class="rs-listing__filters__expandable__list__count">
              ({{ category.count }})
            </span>
          </label>
        </div>
        <div class="rs-listing__filters__expandable__list">
          <label v-for="category in fetchedLanguages" :key="category.slug">
            <input
              type="checkbox"
              v-model="localSelectedLanguages"
              :value="category.slug"
              @change="onSelectedFiltersChange"
            />
            <span v-html="category.name" />
            <span class="rs-listing__filters__expandable__list__count">
              ({{ category.count }})
            </span>
          </label>
        </div>
        <div class="rs-listing__filters__expandable__list">
          <label v-for="category in fetchedCategories" :key="category.slug">
            <input
              type="checkbox"
              v-model="localSelectedCategories"
              :value="category.slug"
              @change="onSelectedFiltersChange"
            />
            <span v-html="category.name" />
            <span class="rs-listing__filters__expandable__list__count">
              ({{ category.count }})
            </span>
          </label>
        </div>
        <div class="rs-listing__filters__expandable__search">
          <input
            type="text"
            v-model="localSearchKeywords"
            :placeholder="fetchedStrings['Keywords']"
            v-on:keyup.enter="onSearchButtonClick"
          />
          <button v-on:click="onSearchButtonClick">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.001"
              height="20.001"
              viewBox="0 0 20.001 20.001"
            >
              <path
                id="Path_133"
                data-name="Path 133"
                d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
                transform="translate(0 17.5)"
                fill="#652981"
              />
            </svg>
          </button>
        </div>
      </div>
    </transition>

    <div class="rs-listing__filters__mobile-version">
      <div class="rs-listing__filters__mobile-version__top">
        <div class="rs-listing__filters__mobile-version__top__filter">
          <span v-html="fetchedStrings['Filter']" />
        </div>

        <transition name="rs-listing-reset">
          <button
            class="rs-listing__filters__mobile-version__top__reset"
            v-if="isFiltering"
            v-on:click="onResetButtonClick"
          >
            <span v-html="fetchedStrings['Reset']" />
          </button>
        </transition>
      </div>

      <hr />

      <div
        class="rs-listing__filters__mobile-version__taxonomy"
        :class="{
          'rs-listing__filters__mobile-version__taxonomy__is-expanded':
            isMobileTaxonomyExpanded_Formats,
        }"
      >
        <button
          class="rs-listing__filters__mobile-version__taxonomy__header"
          @click="toggleMobileTaxonomyExpansion_Formats"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="20"
            viewBox="0 0 25 20"
          >
            <path
              id="Path_139"
              data-name="Path 139"
              d="M23.75-17.5H6.25A1.2,1.2,0,0,0,5-16.354v3.229H6.875v-2.5H8.75v2.5h1.875v-2.5h8.75V-3.75H23.75A1.2,1.2,0,0,0,25-4.9V-16.354A1.2,1.2,0,0,0,23.75-17.5ZM23.125-5.625H21.25V-7.812h1.875Zm0-4.062H21.25v-1.875h1.875Zm0-3.75H21.25v-2.187h1.875ZM5-5A1.251,1.251,0,0,0,6.25-6.25,1.251,1.251,0,0,0,5-7.5,1.251,1.251,0,0,0,3.75-6.25,1.251,1.251,0,0,0,5-5Zm11.25-6.25h-15A1.251,1.251,0,0,0,0-10V1.25A1.251,1.251,0,0,0,1.25,2.5h15A1.251,1.251,0,0,0,17.5,1.25V-10A1.251,1.251,0,0,0,16.25-11.25Zm-.625,9.375L11.692-5.808a.623.623,0,0,0-.442-.183.623.623,0,0,0-.442.183L6.875-1.875,5.442-3.308A.623.623,0,0,0,5-3.491a.623.623,0,0,0-.442.183L1.875-.625v-8.75h13.75Z"
              transform="translate(0 17.5)"
              fill="#652981"
            />
          </svg>

          <span
            class="rs-listing__filters__mobile-version__taxonomy__header__label"
          >
            <span v-html="fetchedStrings['Format']" />
          </span>

          <svg
            class="rs-listing__filters__mobile-version__taxonomy__header__arrow"
            width="11.064"
            height="8.424"
            viewBox="0 0 11.064 8.424"
          >
            <path
              d="M7.584-3.288,1.728-8.808l5.856-5.544h2.568L4.272-8.808l5.88,5.52Z"
              transform="translate(14.352 10.152) rotate(-90)"
              fill="#652981"
            />
          </svg>
        </button>

        <div
          class="rs-listing__filters__mobile-version__taxonomy__list"
          ref="mobileTaxonomyList_Formats"
        >
          <label v-for="series in fetchedFormats" :key="series.slug">
            <div>
              <input
                type="checkbox"
                v-model="localSelectedFormats"
                :value="series.slug"
                @change="onSelectedFiltersChange"
              />
            </div>

            <span v-html="series.name" />
          </label>
        </div>
      </div>

      <div
        class="rs-listing__filters__mobile-version__taxonomy"
        :class="{
          'rs-listing__filters__mobile-version__taxonomy__is-expanded':
            isMobileTaxonomyExpanded_Languages,
        }"
      >
        <button
          class="rs-listing__filters__mobile-version__taxonomy__header"
          @click="toggleMobileTaxonomyExpansion_Languages"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.375"
            height="19.375"
            viewBox="0 0 19.375 19.375"
          >
            <path
              id="Path_141"
              data-name="Path 141"
              d="M9.687-17.187A9.686,9.686,0,0,0,0-7.5,9.686,9.686,0,0,0,9.687,2.187,9.686,9.686,0,0,0,19.375-7.5,9.686,9.686,0,0,0,9.687-17.187ZM8.437-15.2v.441a.626.626,0,0,1-.906.559l-.937-.469A7.886,7.886,0,0,1,8.437-15.2ZM9.687-.758V.312A7.82,7.82,0,0,1,1.875-7.5a7.785,7.785,0,0,1,.687-3.191c.387.574.984,1.461,1.352,2a4.36,4.36,0,0,0,.707.809l.031.027a5.7,5.7,0,0,0,1.234.852c.547.273,1.344.711,1.906,1.02a1.244,1.244,0,0,1,.645,1.094v1.25a1.248,1.248,0,0,0,.367.883A2.932,2.932,0,0,1,9.687-.758Zm1.668.887.68-1.832c.078-.215.129-.438.188-.66a.944.944,0,0,1,.242-.418l.441-.441a1.811,1.811,0,0,0,.535-1.289,1.194,1.194,0,0,0-.348-.844l-.535-.535a1.248,1.248,0,0,0-.883-.367H9.062c-.367-.184-.84-1.25-1.25-1.25a2.652,2.652,0,0,1-1.184-.281L6.2-8a.471.471,0,0,1-.258-.418.466.466,0,0,1,.32-.441L7.477-9.27a.619.619,0,0,1,.605.121l.363.316a.308.308,0,0,0,.2.078h.219a.314.314,0,0,0,.281-.453l-.609-1.219a.309.309,0,0,1,.063-.363l.387-.375a.307.307,0,0,1,.219-.09h.352a.316.316,0,0,0,.223-.09l.312-.312a.314.314,0,0,0,0-.441l-.184-.184a.314.314,0,0,1,0-.441l.4-.4.184-.184a.627.627,0,0,0,0-.883L9.391-15.3c.1,0,.2-.016.3-.016a7.815,7.815,0,0,1,6.98,4.324l-.508.254a.969.969,0,0,0-.359.316L15.035-9.27a.932.932,0,0,0,0,1.039l.7,1.055a.948.948,0,0,0,.551.391L17.43-6.5A7.827,7.827,0,0,1,11.355.129Z"
              transform="translate(0 17.188)"
              fill="#652981"
            />
          </svg>

          <span
            class="rs-listing__filters__mobile-version__taxonomy__header__label"
          >
            <span v-html="fetchedStrings['Language']" />
          </span>

          <svg
            class="rs-listing__filters__mobile-version__taxonomy__header__arrow"
            width="11.064"
            height="8.424"
            viewBox="0 0 11.064 8.424"
          >
            <path
              d="M7.584-3.288,1.728-8.808l5.856-5.544h2.568L4.272-8.808l5.88,5.52Z"
              transform="translate(14.352 10.152) rotate(-90)"
              fill="#652981"
            />
          </svg>
        </button>

        <div
          class="rs-listing__filters__mobile-version__taxonomy__list"
          ref="mobileTaxonomyList_Languages"
        >
          <label v-for="series in fetchedLanguages" :key="series.slug">
            <div>
              <input
                type="checkbox"
                v-model="localSelectedLanguages"
                :value="series.slug"
                @change="onSelectedFiltersChange"
              />
            </div>

            <span v-html="series.name" />
          </label>
        </div>
      </div>

      <div
        class="rs-listing__filters__mobile-version__taxonomy"
        :class="{
          'rs-listing__filters__mobile-version__taxonomy__is-expanded':
            isMobileTaxonomyExpanded_Categories,
        }"
      >
        <button
          class="rs-listing__filters__mobile-version__taxonomy__header"
          @click="toggleMobileTaxonomyExpansion_Categories"
        >
          <svg
            class="rs-listing__filters__mobile-version__taxonomy__header__icon"
            width="20"
            height="16.25"
            viewBox="0 0 20 16.25"
          >
            <path
              d="M3.125-15.625H.625A.625.625,0,0,0,0-15v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-12.5V-15A.625.625,0,0,0,3.125-15.625Zm0,6.25H.625A.625.625,0,0,0,0-8.75v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-6.25v-2.5A.625.625,0,0,0,3.125-9.375Zm0,6.25H.625A.625.625,0,0,0,0-2.5V0A.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75,0V-2.5A.625.625,0,0,0,3.125-3.125Zm16.25-5.312H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-7.187v-.625A.625.625,0,0,0,19.375-8.437Zm0,6.25H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-.937v-.625A.625.625,0,0,0,19.375-2.187Zm0-12.5H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-13.437v-.625A.625.625,0,0,0,19.375-14.687Z"
              transform="translate(0 15.625)"
              fill="#652981"
            />
          </svg>

          <span
            class="rs-listing__filters__mobile-version__taxonomy__header__label"
          >
            <span v-html="fetchedStrings['Category']" />
          </span>

          <svg
            class="rs-listing__filters__mobile-version__taxonomy__header__arrow"
            width="11.064"
            height="8.424"
            viewBox="0 0 11.064 8.424"
          >
            <path
              d="M7.584-3.288,1.728-8.808l5.856-5.544h2.568L4.272-8.808l5.88,5.52Z"
              transform="translate(14.352 10.152) rotate(-90)"
              fill="#652981"
            />
          </svg>
        </button>

        <div
          class="rs-listing__filters__mobile-version__taxonomy__list"
          ref="mobileTaxonomyList_Categories"
        >
          <label v-for="category in fetchedCategories" :key="category.slug">
            <div>
              <input
                type="checkbox"
                v-model="localSelectedCategories"
                :value="category.slug"
                @change="onSelectedFiltersChange"
              />
            </div>
            
            <span v-html="category.name" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fetchedFormats: Array,
    fetchedLanguages: Array,
    fetchedCategories: Array,
    selectedFormats: Array,
    selectedLanguages: Array,
    selectedCategories: Array,
    searchKeywords: String,
    fetchedStrings: Object,
  },
  data() {
    return {
      isExpanded: false,
      localSelectedFormats: null,
      localSelectedLanguages: null,
      localSelectedCategories: null,
      localSearchKeywords: null,
      isMobileTaxonomyExpanded_Formats: false,
      isMobileTaxonomyExpanded_Languages: false,
      isMobileTaxonomyExpanded_Categories: false,
    };
  },
  computed: {
    isFiltering() {
      if (this.localSelectedFormats && this.localSelectedFormats.length)
        return true;
      if (this.localSelectedLanguages && this.localSelectedLanguages.length)
        return true;
      if (this.localSelectedCategories && this.localSelectedCategories.length)
        return true;
      if (this.localSearchKeywords && this.localSearchKeywords.length)
        return true;
      return false;
    },
    isFiltering_Formats() {
      if (this.localSelectedFormats && this.localSelectedFormats.length)
        return true;
      return false;
    },
    isFiltering_Languages() {
      if (this.localSelectedLanguages && this.localSelectedLanguages.length)
        return true;
      return false;
    },
    isFiltering_Categories() {
      if (this.localSelectedCategories && this.localSelectedCategories.length)
        return true;
      return false;
    },
  },
  watch: {
    selectedFormats(value) {
      this.localSelectedFormats = value;
      this.expandIfFiltering();
    },
    selectedLanguages(value) {
      this.localSelectedLanguages = value;
      this.expandIfFiltering();
    },
    selectedCategories(value) {
      this.localSelectedCategories = value;
      this.expandIfFiltering();
    },
    searchKeywords(value) {
      this.localSearchKeywords = value;
      this.expandIfFiltering();
    },
    isMobileTaxonomyExpanded_Formats(value) {
      if (value) {
        if (
          this.$refs.mobileTaxonomyList_Formats &&
          this.$refs.mobileTaxonomyList_Formats.scrollHeight
        ) {
          this.$refs.mobileTaxonomyList_Formats.style.height = `${this.$refs.mobileTaxonomyList_Formats.scrollHeight}px`;
        }
      } else {
        this.$refs.mobileTaxonomyList_Formats.style.height = "";
      }
    },
    isMobileTaxonomyExpanded_Languages(value) {
      if (value) {
        if (
          this.$refs.mobileTaxonomyList_Languages &&
          this.$refs.mobileTaxonomyList_Languages.scrollHeight
        ) {
          this.$refs.mobileTaxonomyList_Languages.style.height = `${this.$refs.mobileTaxonomyList_Languages.scrollHeight}px`;
        }
      } else {
        this.$refs.mobileTaxonomyList_Languages.style.height = "";
      }
    },
    isMobileTaxonomyExpanded_Categories(value) {
      if (value) {
        if (
          this.$refs.mobileTaxonomyList_Categories &&
          this.$refs.mobileTaxonomyList_Categories.scrollHeight
        ) {
          this.$refs.mobileTaxonomyList_Categories.style.height = `${this.$refs.mobileTaxonomyList_Categories.scrollHeight}px`;
        }
      } else {
        this.$refs.mobileTaxonomyList_Categories.style.height = "";
      }
    },
  },
  mounted() {
    this.localSelectedFormats = this.selectedFormats;
    this.localSelectedLanguages = this.selectedLanguages;
    this.localSelectedCategories = this.selectedCategories;
    this.localSearchKeywords = this.searchKeywords;
  },
  methods: {
    expandIfFiltering() {
      if (this.isFiltering) this.isExpanded = true;
      if (this.isFiltering_Formats)
        this.isMobileTaxonomyExpanded_Formats = true;
      if (this.isFiltering_Languages)
        this.isMobileTaxonomyExpanded_Languages = true;
      if (this.isFiltering_Categories)
        this.isMobileTaxonomyExpanded_Categories = true;
    },
    onSelectedFiltersChange(event) {
      this.$emit("selected-filters-change", {
        selectedFormats: this.localSelectedFormats,
        selectedLanguages: this.localSelectedLanguages,
        selectedCategories: this.localSelectedCategories,
      });
    },
    onSearchButtonClick() {
      this.$emit("search-keywords-change", this.localSearchKeywords);
    },
    onResetButtonClick() {
      this.localSelectedFormats = [];
      this.localSelectedLanguages = [];
      this.localSelectedCategories = [];
      this.localSearchKeywords = "";
      this.onSelectedFiltersChange();
      this.onSearchButtonClick();
      this.isExpanded = false;
      this.isMobileTaxonomyExpanded_Formats = false;
      this.isMobileTaxonomyExpanded_Languages = false;
      this.isMobileTaxonomyExpanded_Categories = false;
    },
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    },
    toggleMobileTaxonomyExpansion_Formats() {
      this.isMobileTaxonomyExpanded_Formats =
        !this.isMobileTaxonomyExpanded_Formats;
    },
    toggleMobileTaxonomyExpansion_Languages() {
      this.isMobileTaxonomyExpanded_Languages =
        !this.isMobileTaxonomyExpanded_Languages;
    },
    toggleMobileTaxonomyExpansion_Categories() {
      this.isMobileTaxonomyExpanded_Categories =
        !this.isMobileTaxonomyExpanded_Categories;
    },
  },
};
</script>
